import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/tasksActions'
import * as api from '../api/task'

function* fetchTasks(action) {
  try {
    const payload = yield call(api.getAllTasks, action)
    yield put({ type: constants.TASKS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TASKS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* tasksRefresh() {
  yield takeLatest(constants.TASKS_REFRESH.ACTION, fetchTasks)
}

export function* getAllTasks(action) {
  try {
    const payload = yield call(api.getAllTasks)
    yield put({ type: constants.GET_ALL_TASKS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_TASKS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllTasks() {
  yield takeLatest(constants.GET_ALL_TASKS.ACTION, getAllTasks)
}

function* createTask(action) {
  try {
    const payload = {
      name: action.content.name,
      type: action.content.type,
      description: action.content.description,
      created_date: action.content.created_date,
      updated_date: action.content.updated_date,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createTask, payload)
    yield put({ type: constants.CREATE_TASK.SUCCESS, payload })
    yield call(fetchTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateTask() {
  yield takeLatest(constants.CREATE_TASK.ACTION, createTask)
}

function* editTask(action) {
  try {
    const payload = {
      content: action.content,
      taskId: action.taskId
    }
    yield call(api.editTask, payload)
    yield put({ type: constants.EDIT_TASK.SUCCESS, payload })
    yield call(fetchTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditTask() {
  yield takeLatest(constants.EDIT_TASK.ACTION, editTask)
}

function* deleteTask(action) {
  try {
    const payload = {
      taskId: action.taskId
    }
    yield call(api.deleteTask, payload)
    yield put({ type: constants.DELETE_TASK.SUCCESS, payload })
    yield call(fetchTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteTask() {
  yield takeLatest(constants.DELETE_TASK.ACTION, deleteTask)
}

function* sagaMainQuickAddTask(action) {
  try {
    const payload = {
      name: action.task.name,
      type: action.task.type,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.mainQuickAddTask, payload)
    yield put({ type: constants.MAIN_QUICK_ADD_TASK.SUCCESS, payload })
    yield call(getAllTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MAIN_QUICK_ADD_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchMainQuickAddTask() {
  yield takeLatest(constants.MAIN_QUICK_ADD_TASK.ACTION, sagaMainQuickAddTask)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(tasksRefresh),
    fork(watchGetAllTasks),
    fork(watchCreateTask),
    fork(watchEditTask),
    fork(watchDeleteTask),
    fork(watchMainQuickAddTask)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/tasksSaga.js